<template>
  <div>
    <ParagraphWithTitle
      class="mb-6"
      title-key="charterAllTrips.popularRightNow.title"
    />
    <div class="flex flex-wrap -mx-4">
      <div
        v-for="trip in hardcodedTrips"
        :key="trip.destination_id"
        class="w-12/12 md:w-3/12 mb-4 px-4"
      >
        <CharterSimpleBox
          :image="trip.image_cloudinary"
          :url="`${localeURLs.destinations}/${trip.destination_page_id}`"
          :text="trip.name"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  setup () {
    const { urls: localeURLs } = useLocale()

    return {
      localeURLs,
    }
  },

  data () {
    return {
      hardcodedTrips: [
        {
          'destination_id': 85,
          'destination_page_id': 'alanya',
          'name': 'Alanya',
          'image_cloudinary': 'singlepage/destinations-solresor/alanya_vddcbh',
        },
        {
          'destination_id': 43,
          'name': 'Cypern',
          'destination_page_id': 'cypern',
          'image_cloudinary': 'singlepage/destinations-solresor/cyprus_tsxcha',
        },
        {
          'destination_id': 68,
          'name': 'Mauritius',
          'destination_page_id': 'mauritius',
          'image_cloudinary': 'singlepage/destinations-solresor/Mauritius_Destination_3_ng1kd6.jpg',
        },
        {
          'destination_id': 259,
          'name': 'Khao Lak',
          'destination_page_id': 'khao-lak',
          'image_cloudinary': 'singlepage/destinations-solresor/Khao_Lak_Destination_2_psnmrq.jpg',
        },
      ],
    }
  },
})
</script>
